export const firstChineseChar = (name: string): string => {
  const match = name.match(/[\u4e00-\u9fff]/);
  if (match) {
    return match[0];
  }
  const letters = name.match(/[A-Za-z]/g);
  const two = (letters ? letters.slice(0, 2).join('') : name.charAt(0)).toUpperCase();
  return two || '?';
};